<template>
  <!-- LOCATION -->
  <div class="is-block pb-0" style="position: relative; padding-top: 2px">
    <!-- <p class="has-text-weight-semibold has-text-black-ter"> -->

    <span
      class="icon has-text-grey-dark is-medium mr-quarter"
      style="position: absolute; left: 12px; top: 0;"
    >
      <i class="mdi mdi-map-marker mdi-24px"></i>
    </span>
    <!-- {{ $t('ui.place')}} -->
    <!-- </p> -->

    <div
      class="venue-wrapper py-0"
      style="margin-left: 52px; width: calc(100vw - 52px); "
      itemprop="location"
      itemscope
      itemtype="http://schema.org/Place"
    >
      <div class="is-size-14px">
        <div class="pr-half">
          <div>
            <router-link
              itemprop="name"
              @click.native="$store.commit('appData/SET_DISPLAYED_VENUE_NAME', event.data.eventVenueName)"
              class="has-text-weight-medium has-text-black-ter is-size-15px"
              :to="{name: 'venue-view', params: { venueID: event.data.eventVenueID}}"
            >{{ event.data.eventVenueName }}</router-link>
           
            <transition name="fade">
              <div v-if="event.details">
                <div
                  style="height:0;width:0;overflow:hidden"
                  itemprop="address"
                  itemscope
                  itemtype="http://schema.org/PostalAddress"
                >
                  <span
                    itemprop="streetAddress"
                  >{{ event.data.eventVenueRichAddress.streetAddress }}</span>
                  <span
                    itemprop="addressLocality"
                  >{{ event.data.eventVenueRichAddress.addressLocality }},</span>
                  <span
                    itemprop="addressRegion"
                  >{{ event.data.eventVenueRichAddress.addressRegion }},</span>
                  <span itemprop="postalCode">{{ event.data.eventVenueRichAddress.postalCode }}</span>
                </div>
                <p>{{ event.details.eventVenueAddress }}</p>
                <p
                  class="mt-quarter has-text-link cursor-pointer is-inline-block"
                  @click="showMap = !showMap"
                >
                  {{ showMap ? $t('ui.hideMap') : $t('ui.showMap') }}
                  <span class="icon is-small">
                    <i class="mdi mdi-chevron-down mdi-16px" :class="{ 'mdi-chevron-up': showMap }"></i>
                  </span>
                </p>
              </div>
            </transition>
          </div>
        </div>
        <div class="media-right is-fullheight" v-if="event.data.eventVenueID && false">
          <router-link
            @click.native="$store.commit('appData/SET_DISPLAYED_VENUE_NAME', event.data.eventVenueName)"
            :to="{name: 'venue-view', params: { venueID: event.data.eventVenueID}}"
            class="level-item"
          >
            <figure class="image is-48x48">
              <img class="is-rounded has-border" :src="event.data.eventVenueAvatarURL" />
            </figure>
          </router-link>
        </div>
      </div>
      <GoogleMap
        style="margin-left: -52px; border-radius: 6px; overflow: hidden"
        class="px-1"
        :class=" { 'mt-1': showMap }"
        :show-map="showMap"
        :coord="event.data.eventVenueGeoLocation"
      ></GoogleMap>
    </div>
  </div>

  <!-- ./LOCATION -->
</template>

<script>
import { mapGetters } from "vuex";
import GoogleMap from "@/components/ui/GoogleMap";

export default {
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  components: {
    GoogleMap
  },
  data() {
    return {
      showMap: false
    };
  }
};
</script>

<style lang="scss" scoped>
// .venue-wrapper {
//   padding: 0.75rem  0.75rem !important;
//   border: 1px solid $grey-lighter ;
//   border-radius: 4px;
// }

figure.has-border {
  // border: 1px solid $grey-lighter;
  // border-radius: 50%;
  // border-ra
}
</style>